var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAward(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 508 508",
    style: {
      enableBackground: "new 0 0 508 508"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#324A5E"
    },
    cx: 254,
    cy: 254,
    r: 254
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B3B4E"
    },
    d: "M80,439.2C125.6,482,186.8,508,254,508s128.4-26,174-68.8H80z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B54C"
    },
    d: "M307.2,280.8l-11.6-4.4c15.2-38.8,36.4-54.8,51.6-60.8c20.4-8.4,36-27.2,41.6-50.4 c4.4-18.8,3.6-31.2-2.4-35.6c-11.2-7.6-42,8.4-55.2,17.6l-6.8-10c4.8-3.2,48-32,69.2-17.6c10.8,7.6,13.2,23.2,7.2,48.4 c-6.4,26.8-24.8,48.8-48.8,58.8C333.6,234.8,318,253.2,307.2,280.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B54C"
    },
    d: "M200.8,280.8c-10.8-27.6-26.4-46.4-44.8-54c-24-10-42.4-32-48.8-58.8c-6-25.2-3.6-40.8,7.2-48.4 c21.2-14.4,64.4,14.4,69.2,17.6l-6.8,10c-13.2-9.2-44-25.2-55.2-17.6c-6,4-6.8,16.8-2.4,35.6c5.6,22.8,21.2,41.6,41.6,50.4 c15.2,6.4,36.4,22,51.6,60.8L200.8,280.8z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M208,365.6h91.6c-14.4-16-21.6-36.8-25.2-54.8c-4.4-20.8-3.6-37.6-3.6-37.6h-34.4 c0,0,0.8,16.8-3.6,37.6C229.6,328.8,222.4,349.6,208,365.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B54C"
    },
    d: "M274.8,310.8c-6.8,1.6-13.6,2.8-20.8,2.8s-14-0.8-20.8-2.8c4.4-20.8,3.6-37.6,3.6-37.6h34.4 C271.2,273.2,270.4,290,274.8,310.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M168.8,108.8c-10,20-16,43.6-16,68.8c0,70.8,45.2,128,101.2,128s101.2-57.2,101.2-128 c0-25.6-6-49.2-16-68.8H168.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9EE"
    },
    d: "M321.6,365.6H186.4c-3.2,0-6,2.8-6,6v61.2c0,3.2,2.8,6,6,6h135.2c3.2,0,6-2.8,6-6v-61.2 C327.6,368.4,324.8,365.6,321.6,365.6z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAward);
export default __webpack_public_path__ + "static/media/award.8c76d1fbd121749bd750fc94ebd10000.svg";
export { ForwardRef as ReactComponent };